import API from 'utils/api';
import { store } from 'store';
import { UPDATE_ENTIDAD_INFO } from 'store/reducers/auth/';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/entidades/configuracion/';

const files = ['logo_vertical'];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * POST Configuracion De Entidad
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const postConfiguracionDeEntidad = async (values = {}) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Información actualizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion De Entidad
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const patchConfiguracionDeEntidad = async (values = {}) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(baseURI, formattedValues, config);
    onSuccess(response, 'Información actualizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Configuracion De Entidad
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
// eslint-disable-next-line consistent-return
export const getConfiguracionDeEntidad = async () => {
  try {
    const { entidad } = store.getState().auth;
    const response = await API.get(baseURI);
    store.dispatch({
      type: UPDATE_ENTIDAD_INFO,
      payload: {
        ...entidad,
        configuracion: response.data,
      },
    });
    return response.data;
  } catch (err) {
    onError(err);
    return {};
  }
};
